module.exports = __webpack_public_path__ + "img/pic-16.5dd92ba5.jpg";